import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StylesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Styles",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.56 28.02c.19-.13.34-.3.46-.5.37-.59.59-1.27.63-1.97.32-3.24 2.88-5.14 5.24-3.54s2.73 4.61-.07 6.23q-.69.405-1.44.69H7.3c-.89.35-1.82.61-2.77.78h-.09c-.44.09-.89.15-1.34.2h-.09c-.57 0-1.03-.46-1.03-1.03 0-.38.22-.73.55-.91V28Zm10.87-4.99c-.39.4-1.04.4-1.43 0l-2.85-2.88c-.19-.19-.3-.45-.3-.73 0-.57.45-1.03 1.01-1.04.28 0 .55.11.75.31l2.83 2.88a1.037 1.037 0 0 1-.01 1.47Zm-2.41-5.93L24.79 3.26a2.887 2.887 0 0 1 4.03-.62c1.28.94 1.56 2.74.62 4.03-.17.24-.38.44-.61.62L15 21.12z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.29 18.14H8.71c-.63 0-1.14-.51-1.14-1.14v-4.57C7.57 10.54 9.11 9 11 9h3.43V3.29c0-1.89 1.54-3.43 3.43-3.43h2.29c1.89 0 3.43 1.54 3.43 3.43V9h3.43c1.89 0 3.43 1.54 3.43 3.43V17c0 .63-.51 1.14-1.14 1.14ZM9.86 15.86h18.29v-3.43c0-.63-.51-1.14-1.14-1.14h-4.57c-.63 0-1.14-.51-1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14h-2.29c-.63 0-1.14.51-1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14h-4.57c-.63 0-1.14.51-1.14 1.14v3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 31.86H3a1.14 1.14 0 1 1 0-2.28c2.52 0 4.57-2.05 4.57-4.57v-3.43a1.14 1.14 0 1 1 2.28 0v3.43c0 1.75-.66 3.36-1.75 4.57h15.46c2.52 0 4.57-2.05 4.57-4.57v-8a1.14 1.14 0 1 1 2.28 0v8c0 3.78-3.08 6.86-6.86 6.86Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.86 31.86a1.14 1.14 0 1 1 0-2.28c2.52 0 4.57-2.05 4.57-4.57v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 3.78-3.08 6.86-6.86 6.86ZM16.71 31.86a1.14 1.14 0 1 1 0-2.28c2.52 0 4.57-2.05 4.57-4.57v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 3.78-3.08 6.86-6.86 6.86Z"
      })]
    })
  }));
};